import * as yup from 'yup'

export const client = yup.object().shape({
  empresaId: yup.string().required('La empresa es obligatorio'),
  companiaId: yup.string().required('La compañía es obligatorio'),
})
